/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SideDrawer from './SideDrawer';
import {
  setGlobalFileMetadata,
  setGlobalUploadInProgress,
  setUploadDrawerOpen,
} from 'features/globalUpload/redux/uploadDrawer';
import {
  selectCurrentCaseId,
  selectGlobalUploadFileMetadata,
  selectIsUploadDrawerOpen,
  selectUploadDrawerFolder,
} from 'common/selectors';
import UploadFileContent from './TableWrapper/UploadFileContent';
import { FileMetaData } from './TableWrapper/types';
import { useBatchProcess } from './TableWrapper/useBatchProcess';
import { usePrevious } from 'utils/hooks';
import { Alert } from '@mui/material';
import T from 'i18n';

const UploadDrawerWrapper = () => {
  const dispatch = useDispatch();
  const caseId = useSelector(selectCurrentCaseId);
  const [showSidebar, setShowSideBar] = useState(false);

  const _fileMetadata = useSelector(selectGlobalUploadFileMetadata);
  const [fileMetadata, setFileMetadata] = useState<FileMetaData[]>(_fileMetadata);

  const uploadFolder = useSelector(selectUploadDrawerFolder);
  const previousUploadFolder = usePrevious(uploadFolder);
  const showUploadDrawer = useSelector(selectIsUploadDrawerOpen);

  const { uploadComplete, uploadInProgress, proceedToCreateBatch, reset } =
    useBatchProcess(caseId);

  const _setFileMetadata = (files: FileMetaData[]) => dispatch(setGlobalFileMetadata(files));

  const handleCloseSideDrawer = () => {
    if (uploadInProgress) {
      <Alert severity="error">
        {T.translate('global.uploadDrawer.alert', {
          defaultValue: 'Upload in progress. Please wait',
        })}
      </Alert>;
      return;
    }
    dispatch(setUploadDrawerOpen(false, null));
  };

  const clearAll = () => {
    reset();
    setShowSideBar(false);
  };

  useEffect(() => {
    clearAll();
  }, []);

  useEffect(() => {
    if (fileMetadata) {
      _setFileMetadata(fileMetadata);
    }
  }, [fileMetadata]);

  useEffect(() => {
    if (previousUploadFolder !== uploadFolder) {
      setFileMetadata([]);
    }
  }, [uploadFolder]);

  useEffect(() => {
    dispatch(setGlobalUploadInProgress(uploadInProgress, uploadComplete));
  }, [uploadInProgress, uploadComplete]);

  return (
    <>
      <SideDrawer
        showSidebar={showUploadDrawer}
        onClose={handleCloseSideDrawer}
        title={T.translate('global.uploadDrawer.title', {
          defaultValue: `Upload Documents to ${uploadFolder?.name}`,
        })}
        global={true}
      >
        <UploadFileContent
          fileMetadata={fileMetadata}
          setFileMetadata={setFileMetadata}
          currentFolderId={uploadFolder?.id}
          showSidebar={showSidebar}
          uploadComplete={uploadComplete}
          setShowSideBar={setShowSideBar}
          proceedToCreateBatch={proceedToCreateBatch}
          folder={uploadFolder}
        />
      </SideDrawer>
    </>
  );
};

export default UploadDrawerWrapper;
